import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AuthenticationService } from "../services/authentication/authentication.service";

@Injectable({
    providedIn: "root"
})
export class AuthenticationGuard  {
    private readonly authenticationService = inject(AuthenticationService);
    private readonly router = inject(Router);

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.authenticationService.returnUrl = state.url;
        const {
            requiredRoles, editRoles, publicAccess, redirectToStartIfAuthenticated
        } = childRoute.data;
        if(editRoles) {
            this.authenticationService.editRoles = editRoles;
        }

        return this.isAuthorized$(requiredRoles).pipe(
            // eslint-disable-next-line sonarjs/function-return-type
            map(result => {
                if(redirectToStartIfAuthenticated && result) {
                    return this.router.parseUrl("/");
                }

                if(publicAccess) {
                    return true;
                }

                return result
                    ? true
                    : this.router.parseUrl("/permissiondenied");
            }),
            catchError(() => of(false))
        );
    }

    private isAuthorized$(roles: string[]): Observable<boolean> {
        return this.authenticationService.initializeSession().pipe(
            map(success => {
                if(!success) {
                    return false;
                }

                if(Array.isArray(roles) && roles.length > 0) {
                    return this.authenticationService.hasAnyRole(roles);
                }
                return true;
            })
        );
    }
}
